<div class="digital-banner" *ngIf="pulseDigitalEligibility">
	<a href="https://play.google.com/store/apps/details?id=com.welldoc.ehehealth" target="_blank" class="not-active">
		<img
			[src]="digitalBannerImagePath.playStoreQRcodeImage"
			class="inner-play-store-image"
			alt="Play store Image"
			width="10%"
			height="50%" />
	</a>
	<a href="https://apps.apple.com/us/app/pulse-by-ehe-health/id1619045296" target="_blank" class="not-active">
		<img
			[src]="digitalBannerImagePath.appStoreQRcodeImage"
			class="inner-app-store-image"
			alt="App store Image"
			width="10%"
			height="50%" />
	</a>
	<img
		[src]="digitalBannerImagePath.bannerBackgroundImage"
		alt="Banner Background Image"
		class="background-image"
		width="100%" />
</div>
